import React from 'react';
import './InfluenceMarketing.css';
import influenceImage from '../assets/influmark.jpg'; // You can replace this with the actual image path

const InfluenceMarketing = () => {
  return (
    <section className="influence-marketing-section">
      <div className="container influence-content">
        <div className="influence-text">
          <h5>INFLUENCE MARKETING</h5>
          <h2>Build Trust with the Right Voices</h2>
          <p>
            At <strong>JN IT Digital Solutions</strong>, we connect your brand with trusted influencers who speak directly to your audience. Our influencer marketing strategy is designed to generate awareness, trust, and real business results.
          </p>
          <ul>
            <li>✔ Find the perfect creators for your niche</li>
            <li>✔ Plan engaging & trackable campaigns</li>
            <li>✔ Measure real ROI — reach, conversions, and growth</li>
          </ul>
          <p>
            Whether you're a growing startup or an established brand, we help you leverage influencer credibility to build lasting impressions.
          </p>
          <button className="get-started-btn">Get Started</button>
        </div>
        <div className="influence-image-container">
          <img src={influenceImage} alt="Influence Marketing" />
        </div>
      </div>
    </section>
  );
};

export default InfluenceMarketing;
